export default __webpack_public_path__ + "assets/icons/icon-tick.85cd3e8b92fbc74daf900a54727b8ec9.svg";